module.exports = __webpack_public_path__ + "static/shc1-b1dd34a24524b5b1ea4c5d517896b65d.png";